import React from "react";
import { useState } from "react";
import Currentdate from "./Currentdate";
import axios from "axios";
import Temperature from "./Temperature"
import "./Weather.css"

 export default function Weather(props) {

    const[city,setCity]=useState(props.city)
    const [weatherData,setWeatherData]=useState({ready: false})
    const [Loading,setLoading]=useState(false)

function handleResponse(response) {

setWeatherData({
    ready: true,
    temperature:response.data.main.temp,
    date: new Date(response.data.dt * 1000),
    humidity:response.data.main.humidity,
    description: response.data.weather[0].description,
    wind:response.data.wind.speed,
    city:response.data.name,
    iconUrl:`https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
    
})

setLoading(false)
}

function search() {
    setLoading(true)
    const apiKey="214335cedce3748d2c97d468e1fe7560"
    const apiUrl=`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`
axios.get(apiUrl).then(handleResponse)

}

function handleSubmit(event) {
    event.preventDefault();
    search();
}

function handleRequest(event) {
  setCity(event.target.value)  
}


if(!Loading && !weatherData.ready) {
    return (
        <div className="Weather">
           
           <form className="form" onSubmit={handleSubmit}> 
            <input type="search" placeholder="type the city" className="me-2"  onChange={handleRequest}></input>
            <input type="submit" value="Search" className="btn btn-primary"></input>
           </form>
        </div>
    )  

} else if(!Loading && weatherData.ready)  {
    // let temperature=response.data.temp;
    return (
        <div className="Weather">
           
           <form className="form" onSubmit={handleSubmit}> 
            <input type="search" placeholder="type the city" className="me-2"  onChange={handleRequest}></input>
            <input type="submit" value="Search" className="btn btn-primary"></input>
           </form>
           <h4>{weatherData.city}</h4>
<div className="row mt-4">
    <div className="col-6">
        <ul>
            <li> <Currentdate date={weatherData.date}  /> </li>
            <li className="text-capitalize">{weatherData.description}</li>
        </ul>
 </div>
 <div className="col-6">
 <ul>
<li>Pressure: 1023 kPa</li>
<li>Humidity: {weatherData.humidity}%</li>
<li>Wind: {Math.round(weatherData.wind)} km/h </li>
</ul>
 </div>
</div>
<div className="col-6">
  <div className="float-left">
<img src={weatherData.iconUrl} alt="_blank"></img>

<div className="float-left">
    <Temperature celsius={weatherData.temperature} />

   
        </div> 
        </div> 
 </div>
        </div>
    )  
    } else {

return "Loading...";
}
 }
